// extracted by mini-css-extract-plugin
export default {"scroll":"SupportPage_scroll__QbVLh","flex":"SupportPage_flex__cn2S0","aside":"SupportPage_aside__S8qZu"};